import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TeamService} from "../../service/team.service";

@Component({
  selector: 'app-delete-card-from-team',
  templateUrl: './delete-card-from-team.component.html',
  styleUrl: './delete-card-from-team.component.scss'
})
export class DeleteCardFromTeamComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: { cardId: string },
    protected dialogRef: MatDialogRef<DeleteCardFromTeamComponent>,
    private teamService: TeamService
  ) {
  }

  cancel(): void {
    this.dialogRef.close();
  }

  deleteCardFromTeam(): void {
    this.teamService.deleteCardFromTeam(this.data.cardId).subscribe(() => {
      this.dialogRef.close(true);
    });
  }

}
